// store/modules/planner.js
export default {
    namespaced: true,
    state: {
        staticEvents: {},
    },
    mutations: {
        clearStaticEvents(state) {
            state.staticEvents = {};
        },
        addNewStaticEvent(state, { eventId, event }) {
            state.staticEvents[eventId] = event;
        },
        removeStaticEvent(state, eventId) {
            if (state.staticEvents[eventId]) {
                delete state.staticEvents[eventId];
            }
        },
    },
    getters: {
        staticEvents(state) {
            return state.staticEvents;
        },
    },
};
